module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_right-10dcd435d30e6f92846b96fef6d80ac2.svg";